import { LiquidacionRevisionService } from './../../services/liquidacion-revision.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { LiquidacionModalComponent } from '../partials/liquidaciones-modal/liquidaciones-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {ObrasService} from "../../services/obras.service";
import {HelpersService} from "../../services/tools/helpers.service";
import {WarningModalComponent} from "../tools/modals/warning-modal/warning-modal.component";
import { DomSanitizer } from '@angular/platform-browser'; 
declare var $;


@Component({
  selector: 'app-liquidacion-revision',
  templateUrl: './liquidacion-revision.component.html',
  styleUrls: ['./liquidacion-revision.component.scss']
})
export class LiquidacionRevisionComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;
  @ViewChild(LiquidacionModalComponent) liquidacionModal: LiquidacionModalComponent;

  liquidacionesArray: any[];
  liquidacionesRevision : any[];
  liquidacionesRechazados : any[];
  liquidacionesAprobados : any[];
  public imagePendiente: any;
  public imageEnRev: any;
  public imageRechazado: any;
  public imageAprobado: any;

  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  
  processing: any = false;
  alterTable: any = 'starting';
  auxTable: any = 'starting';
  /* selected */
  /* filters */
  obraFilter: any = {};
  obraFilterOptions: any[];
  fechaInicialFilter: any;
  fechaFinalFilter: any;

  fechaActual: string;
  año:any;
  mes:string;
  dia:string;
  nuevoMes: any;
  auxMes:any;
  meses: string;
  mesLiquidacion:string;
  fechaLiq:any;
  filterMonth:string;
  //mostrar dato
  tipoMov : string;
  mesFilter : Date;
  visiblePendientes:any= true;
  visibleRevision: any = true;
  visibleRechazadas: any = true;
  visibleAprobadas: any = true;
  loading:any= true;
  dataRevision:any = 'starting';
  dataRechazado:any = 'starting';
  dataAprobado:any = 'starting';

  liquidaciones: any = {imagen:''}
  defaultImage: string;

  constructor(  private obrasService: ObrasService,
                private helperService: HelpersService,
                private liquidacionRevisionService: LiquidacionRevisionService,
                private sanitizer: DomSanitizer) {
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.meses = "meses,Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre"
    this.defaultImage = 'assets/images/bg-auth.jpg';
  }
  ngOnInit() {
      this.getObras();
      this.getFechaActual();
  }

  createLiquidaciones(){
    this.liquidacionModal.open();
  }

  getObras(){
    this.liquidacionRevisionService.getObratoSelect()
    .subscribe((response)=>{
      this.obraFilterOptions = response.json().content;
    });
  }

  changeObraFilter($event) {
    this.obraFilter = $event;
  }
  getLiquidaciones() {
    this.liquidacionRevisionService.getLiquidacionesFilter("",this.nuevoMes+"-"+this.dia)
        .subscribe(response => {
          const content = response.json().content;
          this.liquidacionesArray = content.pendientes;
          this.liquidacionesRevision = content.revision;
          this.liquidacionesRechazados = content.rechazados;
          this.liquidacionesAprobados = content.aprobados;
          //console.log(":this.liquidacionesArray:",this.liquidacionesArray);
          //console.log(":this.liquidacionesRevision:",this.liquidacionesRevision);
          //console.log(":this.liquidacionesRechazados:",this.liquidacionesRechazados);
          //console.log(":this.liquidacionesAprobados:",this.liquidacionesAprobados);
          this.alterTable = (this.liquidacionesArray.length > 0)? false: 'not_found';
          this.dataRevision = (this.liquidacionesRevision.length > 0)? false: 'not_found';
          this.dataRechazado = (this.liquidacionesRechazados.length > 0)? false: 'not_found';
          this.dataAprobado = (this.liquidacionesAprobados.length > 0)? false: 'not_found';
          if(this.alterTable =='not_found'&& this.dataRevision == 'not_found' && this.dataRechazado  == 'not_found' && this.dataAprobado =='not_found'){
            this.auxTable = 'sinDatos';
            this.loading = false;
          }
          else{
            this.auxTable = 'conDatos';
            this.loading = false;
          }
          if (this.liquidacionesArray.length > 0) {
            this.loadFotografiaPendientes(0);
          }
          if (this.liquidacionesRevision.length > 0) {
            this.loadFotografiaEnviados(0);
          }
          if (this.liquidacionesRechazados.length > 0) {
            this.loadFotografiaRechazados(0);
          }

          if (this.liquidacionesAprobados.length > 0) {
            this.loadFotografiaAprobado(0);
          }
        }, (error) => {
          this.helperService.httpGlobalError(error);
        });
  }

  loadFotografiaPendientes(posicion) {
    let liquidacion = this.liquidacionesArray[posicion];
    if (liquidacion.obras.urlImagen) {
      this.obrasService.getImageUrl(liquidacion.obras.idObras).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        liquidacion.imagePendiente = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
      if (this.liquidacionesArray.length -1  > posicion) {
        this.loadFotografiaPendientes(posicion+1);
      }
    } else {
        if (this.liquidaciones.length -1  > posicion) {
            this.loadFotografiaPendientes(posicion+1);
        }
    }
  }
  loadFotografiaEnviados(posicion) {
    let liquidacion = this.liquidacionesRevision[posicion];
    if (liquidacion.obras.urlImagen) {
      this.obrasService.getImageUrl(liquidacion.obras.idObras).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        liquidacion.imageEnRev = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
      if (this.liquidacionesRevision.length -1  > posicion) {
        this.loadFotografiaEnviados(posicion+1);
      }
    } else {
        if (this.liquidacionesRevision.length -1  > posicion) {
            this.loadFotografiaEnviados(posicion+1);
        }
    }
  }
  loadFotografiaRechazados(posicion) {
    let liquidacion = this.liquidacionesRechazados[posicion];
    if (liquidacion.obras.urlImagen) {
      this.obrasService.getImageUrl(liquidacion.obras.idObras).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        liquidacion.imageRechazado = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
      if (this.liquidacionesRechazados.length -1  > posicion) {
        this.loadFotografiaRechazados(posicion+1);
      }
    } else {
        if (this.liquidacionesRechazados.length -1  > posicion) {
            this.loadFotografiaRechazados(posicion+1);
        }
    }
  }

  loadFotografiaAprobado(posicion) {
    let liquidacion = this.liquidacionesAprobados[posicion];
    if (liquidacion.obras.urlImagen) {
      this.obrasService.getImageUrl(liquidacion.obras.idObras).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        liquidacion.imageAprobado = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
      if (this.liquidacionesAprobados.length -1  > posicion) {
        this.loadFotografiaAprobado(posicion+1);
      }
    } else {
        if (this.liquidacionesAprobados.length -1  > posicion) {
            this.loadFotografiaAprobado(posicion+1);
        }
    }
  }

  showPendientes(){
    if(this.visiblePendientes == true){
      this.visiblePendientes = false;
    }
    else{
      this.visiblePendientes = true;
    }
  }
  showRevision(){
    if(this.visibleRevision == true){
      this.visibleRevision = false;
    }
    else{
      this.visibleRevision = true;
    }
  }
  showRechazadas(){
    if(this.visibleRechazadas == true){
      this.visibleRechazadas = false;
    }
    else{
      this.visibleRechazadas = true;
    }
  }
  showAprobadas(){
    if(this.visibleAprobadas == true){
      this.visibleAprobadas = false;
    }
    else{
      this.visibleAprobadas = true;
    }
  }

  getFechaActual() {
    this.liquidacionRevisionService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fechaActual = content.fecha_inicio;
          this.nuevoMes = content.fecha_inicio.split("-")[0]+"-"+content.fecha_inicio.split("-")[1];
          this.dia = content.fecha_inicio.split("-")[2];
          //this.getMes(this.fechaActual);
          this.getLiquidaciones();
        }, (error) => {
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  getMes(data){
    var cadena = data,separador = "-",arregloDeSubCadenas = cadena.split(separador);
          this.año = arregloDeSubCadenas[0];
          this.mes = arregloDeSubCadenas[1];
          this.dia = arregloDeSubCadenas[2];
          this.auxMes = parseInt(this.mes);
          this.año = parseInt(this.año);
          if(this.mes == '01'){
            this.auxMes = 12;
            this.año = this.año - 1;
          }else{
            this.auxMes = this.auxMes - 1;
          }if (this.auxMes < 10) {
            this.nuevoMes = this.año+ "-0"+ this.auxMes;
          }else{
            this.nuevoMes = this.año+ "-"+ this.auxMes;
          }
    this.getLiquidaciones();
  }

  filter() {
    if(this.obraFilter.nombreObra){
      this.liquidacionRevisionService.getLiquidacionesFilter(this.obraFilter.nombreObra,this.nuevoMes+"-"+this.dia)
      .subscribe(response => {
        const content = response.json().content;
        this.liquidacionesRevision = content.revision;
        this.liquidacionesRechazados = content.rechazados;
        this.liquidacionesAprobados = content.aprobados;
        this.liquidacionesArray = content.pendientes;
        this.liquidacionesRevision = content.revision;
        //console.log("this.liquidacionesAprobados:",this.liquidacionesAprobados);
         this.alterTable = (this.liquidacionesArray.length > 0)? false: 'not_result';
        this.dataRevision = (this.liquidacionesRevision.length > 0)? false: 'not_result';
        this.dataRechazado = (this.liquidacionesRechazados.length > 0)? false: 'not_result';
        this.dataAprobado = (this.liquidacionesAprobados.length > 0)? false: 'not_result';

        if (this.liquidacionesArray.length > 0) {
            this.loadFotografiaPendientes(0);
          }
          if (this.liquidacionesRevision.length > 0) {
            this.loadFotografiaEnviados(0);
          }
          if (this.liquidacionesRechazados.length > 0) {
            this.loadFotografiaRechazados(0);
          }

          if (this.liquidacionesAprobados.length > 0) {
            this.loadFotografiaAprobado(0);
          }
        this.auxTable = 'conDatos';
      }, (error) => {
        // se resuelven errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
    }
    else{
      this.liquidacionRevisionService.getLiquidacionesFilter("",this.nuevoMes+"-"+this.dia)
        .subscribe(response => {
          const content = response.json().content;
          this.liquidacionesArray = content.pendientes;
          this.liquidacionesRevision = content.revision;
          this.liquidacionesRechazados = content.rechazados;
          this.liquidacionesAprobados = content.aprobados;
          //console.log(":this.liquidacionesAprobados:",this.liquidacionesAprobados);
          this.alterTable = (this.liquidacionesArray.length > 0)? false: 'not_found';
          this.dataRevision = (this.liquidacionesRevision.length > 0)? false: 'not_found';
          this.dataRechazado = (this.liquidacionesRechazados.length > 0)? false: 'not_found';
          this.dataAprobado = (this.liquidacionesAprobados.length > 0)? false: 'not_found';
          
          if (this.liquidacionesArray.length > 0) {
            this.loadFotografiaPendientes(0);
          }
          if (this.liquidacionesRevision.length > 0) {
            this.loadFotografiaEnviados(0);
          }
          if (this.liquidacionesRechazados.length > 0) {
            this.loadFotografiaRechazados(0);
          }

          if (this.liquidacionesAprobados.length > 0) {
            this.loadFotografiaAprobado(0);
          }
          this.auxTable = 'conDatos';
        }, (error) => {
          this.helperService.httpGlobalError(error);
        });
    }
  }

  getFechaLiquidacion(data){
    var cadena = data,separador = "-",arregloDeSubCadenas = cadena.split(separador);
          this.año = arregloDeSubCadenas[0];
          this.mes = arregloDeSubCadenas[1];
          this.auxMes = parseInt(this.mes);
    var cadena2 = this.meses,separador2 = ",",arregloDeSubCadenas2 = cadena2.split(separador2);
          this.mesLiquidacion = arregloDeSubCadenas2[this.auxMes];
    this.fechaLiq = this.mesLiquidacion +" "+ this.año;
    return this.fechaLiq;
  }

  writePermission() {
    return this.liquidacionRevisionService.writePermission();
  }

  canExport() {
    return this.liquidacionRevisionService.canExport();
  }
 
}


// WEBPACK FOOTER //
// ./src/app/components/liquidacion-revision/liquidacion-revision.component.ts